import {
  CheckCircle,
  Clock,
  Warning,
  XCircle,
} from '@phosphor-icons/react';

export const STATUS_CONFIG = {
  pending: { label: 'Pending', color: 'bg-amber-100 text-amber-700', icon: Clock },
  accepted: { label: 'Accepted', color: 'bg-green-100 text-green-700', icon: CheckCircle },
  expired: { label: 'Expired', color: 'bg-slate-100 text-slate-500', icon: Warning },
  revoked: { label: 'Revoked', color: 'bg-red-100 text-red-700', icon: XCircle },
};

export const ROLES = ['Admin', 'Office Manager', 'Biller', 'Viewer'];

export const DEFAULT_FORM = {
  email: '',
  name: '',
  role: 'Biller',
  expires_in_days: 7,
  message: '',
};

export { formatDate } from '../../lib/utils';
